import { useEffect, useState } from "react";
import { Card, Table } from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import { fetchSellingInvoices } from "redux/actions/invoice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import LeftSidebar from "../../components/left_sidebar";
import AddMetaTags from "../../components/add_meta_tags";
import NumberFormat from "../../components/number_format";

const getStatusInfo = status => {
  const STATUS_MAP = {
    delivered: { text: "Đã giao hàng", color: "success" },
    pending: { text: "Chờ xác nhận", color: "warning" },
    cancelled: { text: "Đã hủy", color: "danger" },
    failed_delivery: { text: "Giao thất bại", color: "danger" },
    returned: { text: "Trả hàng", color: "warning" },
    ready_to_ship: { text: "Chờ lấy hàng", color: "warning" },
    shipped: { text: "Đang giao", color: "warning" },
    rejected: { text: "Người bán từ chối đơn", color: "danger" },
    admin_rejected: { text: "Quản trị viên từ chối đơn", color: "danger" },
  };
  return STATUS_MAP[status] || { text: "", color: "primary" };
};

const InvoiceRow = ({ invoice }) => {
  const { text, color } = getStatusInfo(invoice.status);
  const createdAt = invoice.invoice_user_id
    ? invoice.invoice_user_created_at
    : invoice.created_at;
  const total = invoice.invoice_user_id
    ? invoice.total_price
    : invoice.price_total;

  return (
    <tr className="text-center">
      <td className="sku-detail product-detail">
        <Link to={`/thanh-vien/thong-tin-don-hang-mua/${invoice.id}`}>
          {invoice.sku}
        </Link>
      </td>
      <td>{invoice.name}</td>
      <td>
        <small>{moment(createdAt).format("DD-MM-YYYY")}</small>
      </td>
      <td>
        <NumberFormat>{total}</NumberFormat>
        <span className="ml-1 red-clr font-italic">VNĐ</span>
      </td>
      <td>
        <div className={`mt-1 badge badge-${color}`}>{text}</div>
      </td>
    </tr>
  );
};

const ListInvoiceRevenue = () => {
  const dispatch = useDispatch();
  const [keyword, setKeyword] = useState("");
  const [searchParams] = useSearchParams();

  const listSellingInvoices = useSelector(
    state => state.invoices.listSellingInvoices.data || []
  );

  const status = searchParams.get("status");
  const start_date = searchParams.get("startDate");
  const end_date = searchParams.get("endDate");
  const info_invoice = "both";

  useEffect(() => {
    const sku_keyword = keyword;
    dispatch(
      fetchSellingInvoices({
        page: 1,
        limit: 24,
        status,
        type: "sales",
        end_date,
        start_date,
        info_invoice,
        sku_keyword,
      })
    );
  }, [keyword, status, start_date, end_date]);

  return (
    <div>
      <AddMetaTags title="Danh sách đơn hàng có doanh thu" />
      <div className="row">
        <LeftSidebar />
        <div className="col-md-9 col-sm-12">
          <div className="cont-center saved-items">
            <Card className="p-0">
              <Card.Body>
                <div className="search-box my-3">
                  <input
                    className="form-control search-input"
                    type="text"
                    placeholder="Nhập mã đơn hàng"
                    value={keyword}
                    onChange={e => setKeyword(e.target.value)}
                  />
                  <span className="icon-search" />
                </div>

                <Table className="mt-2">
                  <thead className="text-center">
                    <tr>
                      <th>Mã đơn hàng</th>
                      <th>Người đặt</th>
                      <th>Thời gian đặt</th>
                      <th>Tổng tiền</th>
                      <th>Trạng thái</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listSellingInvoices.length > 0 ? (
                      listSellingInvoices.map((item, idx) => (
                        <InvoiceRow key={idx} invoice={item} />
                      ))
                    ) : (
                      <tr>
                        <td colSpan={5} className="text-center empty-data">
                          Không có đơn hàng
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListInvoiceRevenue;
